window.addEventListener('DOMContentLoaded', () => {
  const interval = setInterval(() => {
    if (window.Swiper) {
      clearInterval(interval);

      const allSwipers = [];

      // Utility: set aria-hidden and tabindex together on a slide
      const setSlideHidden = (slide, hidden) => {
        slide.setAttribute('aria-hidden', hidden ? 'true' : 'false');
        if (hidden) {
          slide.setAttribute('tabindex', '-1');
        } else {
          slide.removeAttribute('tabindex');
        }
      };

      // Utility: update aria-hidden on slides
      const updateAriaHidden = (swiper) => {
        const slidesPerView = swiper.params.slidesPerView === 'auto'
          ? Math.floor(swiper.width / swiper.slides[0].offsetWidth) || 1
          : swiper.params.slidesPerView;

        swiper.slides.forEach((slide, index) => {
          if (index >= swiper.activeIndex && index < swiper.activeIndex + slidesPerView) {
            setSlideHidden(slide, false);
          } else {
            setSlideHidden(slide, true);
          }
        });
      };

      // Initialize a Swiper with aria-hidden updates
      const setupSwiper = (elem, options = {}) => {
        const swiperInstance = new Swiper(elem, {
          ...options,
          on: {
            init: function () {
              updateAriaHidden(this);
            },
            slideChange: function () {
              updateAriaHidden(this);
            },
            resize: function () {
              updateAriaHidden(this);
            },
          },
        });
        allSwipers.push(swiperInstance);
      };

      // Initialize all Swipers
      document.querySelectorAll('.article-tab-swiper').forEach((elem) => {
        setupSwiper(elem, {
          breakpoints: {
            1280: {
              slidesPerGroup: 2,
              slidesPerView: 4,
              spaceBetween: 8,
            },
          },
          loop: false,
          slidesPerGroup: 1,
          slidesPerView: 'auto',
          spaceBetween: 8,
          navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
          },
        });
      });

      document.querySelectorAll('.article-main-swiper').forEach((elem) => {
        setupSwiper(elem, {
          breakpoints: {
            1280: {
              slidesPerGroup: 2,
              slidesPerView: 3,
              spaceBetween: 16,
            },
          },
          slidesPerGroup: 1,
          slidesPerView: 'auto',
          spaceBetween: 8,
          navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
          },
        });
      });

      document.querySelectorAll('.podcast-blogs-swiper').forEach((elem) => {
        setupSwiper(elem, {
          effect: 'fade',
          fadeEffect: { crossFade: true },
        });
      });

      // Set initial aria-hidden state on Swiper containers
      allSwipers.forEach((swiper) => {
        swiper.el.closest('.blog-tab-panel')?.classList.contains('tw-hidden')
          ? swiper.el.setAttribute('aria-hidden', 'true')
          : swiper.el.setAttribute('aria-hidden', 'false');
      });
    }
  }, 200);

  // Blog tab switching
  document.querySelectorAll('.blog-tab').forEach((tab) => {
    tab.addEventListener('click', function () {
      const targetPanel = document.getElementById(this.getAttribute('aria-controls'));

      if (targetPanel) {
        document.querySelectorAll('.blog-tab-panel').forEach((panel) => {
          const tabButton = document.getElementById(panel.getAttribute('aria-labelledby'));

          if (panel.id !== targetPanel.id) {
            panel.classList.add('tw-hidden');
            tabButton?.classList.replace('tw-border-black', 'tw-border-transparent');
            tabButton?.setAttribute('aria-selected', false);
            panel.querySelectorAll('.swiper').forEach((swiperElem) => swiperElem.setAttribute('aria-hidden', 'true'));
            panel.querySelectorAll('.swiper').forEach((swiperElem) => {
              swiperElem.swiper?.update();
              swiperElem.swiper?.slides.forEach(slide => setSlideHidden(slide, true));
            });
          } else {
            panel.classList.remove('tw-hidden');
            tabButton?.classList.replace('tw-border-transparent', 'tw-border-black');
            tabButton?.setAttribute('aria-selected', true);
            panel.querySelectorAll('.swiper').forEach((swiperElem) => swiperElem.setAttribute('aria-hidden', 'false'));
            panel.querySelectorAll('.swiper').forEach((swiperElem) => {
              swiperElem.swiper?.update();
              swiperElem.swiper?.slides.forEach(slide => setSlideHidden(slide, false));
            });
          }
        });
      }
    });
  });

  // Podcast list height adjustment
  document.querySelectorAll('.blog-podcast').forEach((elem) => {
    const main = elem.querySelector('.main-podcast-image');
    const list = elem.querySelector('.main-podcast-list');

    if (main && list) {
      list.style.maxHeight = `${main.clientHeight}px`;
    }
  });

  // Article tabs expand
  document.querySelectorAll('.article-tabs-expand').forEach((elem) => {
    elem.addEventListener('click', function () {
      const tabs = this.parentElement.querySelector('ul');

      if (tabs) {
        if (this.classList.contains('tw-rotate-180')) {
          this.classList.remove('tw-rotate-180');

          tabs.querySelectorAll('li').forEach((elem) => {
            const selected = elem.querySelector('button').getAttribute('aria-selected');
            if (selected !== 'true') {
              elem.classList.replace('tw-block', 'tw-hidden');
              elem.classList.add('tw-hidden');
            }
          });
        } else {
          this.classList.add('tw-rotate-180');
          tabs.querySelectorAll('li').forEach((elem) => elem.classList.replace('tw-hidden', 'tw-block'));
        }
      }
    });
  });

  document.querySelectorAll('.podcast-blog-button').forEach((elem) => {
    elem.addEventListener('click', function () {
      const swiper = this.closest('.blog-podcast').querySelector('.podcast-blogs-swiper');
      const index = this.dataset.index;

      if (swiper) {
        swiper.swiper.slideTo(index);
      }
    });
  });

  const blogTabs = Array.from(document.querySelectorAll('.blog-tab'));

  blogTabs.forEach((tab, index) => {
    tab.addEventListener('keydown', function (e) {
      let newIndex = null;

      switch (e.key) {
        case 'ArrowRight':
          newIndex = (index + 1) % blogTabs.length;
          break;
        case 'ArrowLeft':
          newIndex = (index - 1 + blogTabs.length) % blogTabs.length;
          break;
        case 'Home':
          newIndex = 0;
          break;
        case 'End':
          newIndex = blogTabs.length - 1;
          break;
        default:
          return; 
      }

      e.preventDefault();

      blogTabs[newIndex].focus();

      blogTabs.forEach((t, i) => {
        t.setAttribute('aria-selected', i === newIndex ? 'true' : 'false');
      });

      const targetPanelId = blogTabs[newIndex].getAttribute('aria-controls');
      const targetPanel = document.getElementById(targetPanelId);

      if (targetPanel) {
        document.querySelectorAll('.blog-tab-panel').forEach((panel) => {
          panel.setAttribute('aria-hidden', panel.id === targetPanel.id ? 'false' : 'true');

          panel.querySelectorAll('.swiper').forEach((swiperElem) => {
            const swiper = swiperElem.swiper;
            if (swiper) {
              swiper.slides.forEach((slide, idx) => {
                const slidesPerView = swiper.params.slidesPerView === 'auto'
                  ? Math.floor(swiper.width / swiper.slides[0].offsetWidth) || 1
                  : swiper.params.slidesPerView;

                if (panel.id === targetPanel.id &&
                    idx >= swiper.activeIndex &&
                    idx < swiper.activeIndex + slidesPerView) {
                  setSlideHidden(slide, false);
                } else {
                  setSlideHidden(slide, true);
                }
              });
            }
          });
        });
      }
    });
  });

});


